/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductListResVo } from './ProductListResVo';
import {
    ProductListResVoFromJSON,
    ProductListResVoFromJSONTyped,
    ProductListResVoToJSON,
    ProductListResVoToJSONTyped,
} from './ProductListResVo';

/**
 * 
 * @export
 * @interface ProductListPageResVo
 */
export interface ProductListPageResVo {
    /**
     * 当前页
     * @type {number}
     * @memberof ProductListPageResVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof ProductListPageResVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof ProductListPageResVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<ProductListResVo>}
     * @memberof ProductListPageResVo
     */
    records?: Array<ProductListResVo>;
    /**
     * 上架商品数，按 SKU 统计
     * @type {number}
     * @memberof ProductListPageResVo
     */
    onShelfCount?: number;
    /**
     * 下架商品数，按 SKU 统计
     * @type {number}
     * @memberof ProductListPageResVo
     */
    offShelfCount?: number;
}

/**
 * Check if a given object implements the ProductListPageResVo interface.
 */
export function instanceOfProductListPageResVo(value: object): value is ProductListPageResVo {
    return true;
}

export function ProductListPageResVoFromJSON(json: any): ProductListPageResVo {
    return ProductListPageResVoFromJSONTyped(json, false);
}

export function ProductListPageResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductListPageResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(ProductListResVoFromJSON)),
        'onShelfCount': json['onShelfCount'] == null ? undefined : json['onShelfCount'],
        'offShelfCount': json['offShelfCount'] == null ? undefined : json['offShelfCount'],
    };
}

export function ProductListPageResVoToJSON(json: any): ProductListPageResVo {
    return ProductListPageResVoToJSONTyped(json, false);
}

export function ProductListPageResVoToJSONTyped(value?: ProductListPageResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(ProductListResVoToJSON)),
        'onShelfCount': value['onShelfCount'],
        'offShelfCount': value['offShelfCount'],
    };
}

